// src/pages/Inscription.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Inscription() {
  const { register } = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]       = useState({ prenom: '', ville: '', email: '', password: '', bio: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await register(form);
      setSuccess(true);
      setTimeout(() => navigate('/carte'), 1800);
    } catch (err) {
      setError(err.response?.data?.error || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  if (success) return (
    <main className="k-page" style={{ padding: '48px 24px', textAlign: 'center' }}>
      <div style={s.successIcon}>
        <span className="material-symbols-outlined" style={{ fontSize: 36, color: 'var(--c-primary)', fontVariationSettings: "'FILL' 1" }}>eco</span>
      </div>
      <h2 style={s.successH2}>Bienvenue sur Kindeo 🌿</h2>
      <p style={s.successText}>Votre profil est créé. Redirection en cours…</p>
    </main>
  );

  return (
    <main className="k-page">
      <div style={s.wrap}>
        <div style={s.header} className="fade-up">
          <h1 style={s.h1}>Rejoindre Kindeo</h1>
          <p style={s.sub}>Un espace simple pour rencontrer des personnes près de chez vous.</p>
        </div>

        <form onSubmit={submit}>
          {error && <div className="k-error">{error}</div>}

          <div style={s.row}>
            <div style={s.group}>
              <label className="k-label">Prénom</label>
              <input name="prenom" className="k-input" placeholder="Marie" value={form.prenom} onChange={handle} required />
            </div>
            <div style={s.group}>
              <label className="k-label">Ville</label>
              <input name="ville" className="k-input" placeholder="Lyon" value={form.ville} onChange={handle} required />
            </div>
          </div>

          <div style={s.group}>
            <label className="k-label">Email</label>
            <input name="email" type="email" className="k-input" placeholder="vous@email.fr" value={form.email} onChange={handle} required />
          </div>

          <div style={s.group}>
            <label className="k-label">Mot de passe</label>
            <input name="password" type="password" className="k-input" placeholder="8 caractères minimum" value={form.password} onChange={handle} required minLength={8} />
          </div>

          <div style={{ height: 1, background: 'var(--c-border)', margin: '24px 0' }} />

          <div style={s.group}>
            <label className="k-label">Ce que j'aimerais partager <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optionnel)</span></label>
            <textarea name="bio" className="k-input" placeholder="Ex : j'aime les balades tranquilles, discuter autour d'un café…" value={form.bio} onChange={handle} />
            <p style={{ fontFamily: 'Manrope,sans-serif', fontSize: 12, color: 'var(--c-text-3)', marginTop: 6 }}>Quelques mots suffisent. Cela aide les autres à vous découvrir.</p>
          </div>

          <div style={s.consent}>
            <span className="material-symbols-outlined" style={{ color: 'var(--c-primary)', fontSize: 18, flexShrink: 0 }}>shield</span>
            <p style={{ fontFamily: 'Manrope,sans-serif', fontSize: 12, color: 'var(--c-primary)', fontWeight: 600, lineHeight: 1.4 }}>
              Vos informations restent privées et ne sont jamais vendues.
            </p>
          </div>

          <button type="submit" className="k-button" disabled={loading}>
            {loading ? <div className="k-spinner" style={{ width: 20, height: 20 }} /> : 'Rejoindre'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontFamily: 'Manrope,sans-serif', fontSize: 13, color: 'var(--c-text-3)', marginTop: 20 }}>
          Déjà membre ? <Link to="/connexion" style={{ color: 'var(--c-primary)', fontWeight: 700 }}>Se connecter</Link>
        </p>
      </div>
    </main>
  );
}

// ── CONNEXION ────────────────────────────────────────────────
export function Connexion() {
  const { login }    = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]       = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/carte');
    } catch (err) {
      setError(err.response?.data?.error || 'Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="k-page">
      <div style={s.wrap}>
        <div style={s.header} className="fade-up">
          <h1 style={s.h1}>Se connecter</h1>
          <p style={s.sub}>Bon retour sur Kindeo.</p>
        </div>

        <form onSubmit={submit}>
          {error && <div className="k-error">{error}</div>}
          <div style={s.group}>
            <label className="k-label">Email</label>
            <input name="email" type="email" className="k-input" placeholder="vous@email.fr" value={form.email} onChange={handle} required />
          </div>
          <div style={s.group}>
            <label className="k-label">Mot de passe</label>
            <input name="password" type="password" className="k-input" placeholder="Votre mot de passe" value={form.password} onChange={handle} required />
          </div>
          <button type="submit" className="k-button" style={{ marginTop: 24 }} disabled={loading}>
            {loading ? <div className="k-spinner" style={{ width: 20, height: 20 }} /> : 'Se connecter'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontFamily: 'Manrope,sans-serif', fontSize: 13, color: 'var(--c-text-3)', marginTop: 20 }}>
          Pas encore membre ? <Link to="/inscription" style={{ color: 'var(--c-primary)', fontWeight: 700 }}>Rejoindre Kindeo</Link>
        </p>
      </div>
    </main>
  );
}

const s = {
  wrap:       { padding: '40px 24px 48px' },
  header:     { marginBottom: 32 },
  h1:         { fontFamily: 'Manrope,sans-serif', fontSize: 30, fontWeight: 800, color: 'var(--c-primary)', letterSpacing: '-0.7px', marginBottom: 8 },
  sub:        { fontSize: 15, color: 'var(--c-text-2)', lineHeight: 1.65 },
  row:        { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 },
  group:      { marginBottom: 16 },
  consent:    { background: 'var(--c-primary-lt)', borderRadius: 'var(--radius-md)', padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 24 },
  successIcon:{ width: 72, height: 72, borderRadius: '50%', background: 'var(--c-primary-lt)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  successH2:  { fontFamily: 'Manrope,sans-serif', fontSize: 24, fontWeight: 800, color: 'var(--c-primary)', marginBottom: 10 },
  successText:{ fontSize: 15, color: 'var(--c-text-2)' },
};
